'use client';

import type { ButtonProps } from '@enlighten/design-system/dist/Button';
import Button from '@enlighten/design-system/dist/Button';

export interface ZendeskButtonProps extends ButtonProps {}

export default function ZendeskButton({ onClick, ...props }: ZendeskButtonProps) {
	return (
		<Button
			onClick={(e) => {
				/** @todo 젠데스크 Legacy API 사용 중. 바꿔야 함 */
				const nodeList = document.querySelectorAll(`iframe[title="${process.env.NODE_ENV === 'production' ? '메시징 창을 시작하는 버튼' : '메시징 창을 시작하는 버튼, 대화 진행 중'}"]`);
				const button = (nodeList[nodeList.length - 1] as HTMLIFrameElement)?.contentWindow?.document?.querySelector('button[aria-label="메시징 창 열기"]') as HTMLButtonElement | null;
				button && button.click();
				onClick && onClick(e);
			}}
			{...props}
		/>
	);
}
